import { Col, Container, Row, Typography } from 'darrius';
import { type TOnboardingProps } from '../@interfaces';

import styles from './Onboarding.module.scss';

interface IOnboardingProps {
  data: TOnboardingProps[];
}

export const Onboarding = ({ data }: IOnboardingProps) => {
  return (
    <Container>
      <Row className="center-sm space-bottom">
        {data.map((item) => (
          <Col className="col-sm-12 col-md-2 space-bottom" key={item.id}>
            <img src={item.img} alt={item.alt} />
            <Typography.Text className={styles.text}>
              {item.description}
            </Typography.Text>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
